import { inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as actions from '../actions/featured-news.action';
import { switchMap, map, catchError } from 'rxjs/operators';
import { NewsService } from '../../services';

export const loadFeaturedNews$ = createEffect(
  (actions$ = inject(Actions), service = inject(NewsService)) => {
    return actions$.pipe(
      ofType(actions.LoadFeaturedNews),
      switchMap(() =>
        service.getNewsFeatured().pipe(
          map(news => actions.LoadFeaturedNewsSuccess({ news })),
          catchError(error => of(actions.LoadFeaturedNewsFail({ error })))
        )
      )
    );
  },
  { functional: true }
);
